import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { IWebSite } from "../../models/WebSite";
import { Search } from "../../shared/Search";
import { Fetch } from "../../shared/Fetch";
import { IModel } from "./WebsiteTemplate";
import { IPermissionProps } from "../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { InputTextarea } from "primereact/inputtextarea";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
}

export const Table = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IWebSite>, loading: boolean });
    const [dollarHistoryTableData, setDollarHistoryTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const [activeIndex, setActiveIndex] = useState<number | number[]>();
    const [openDollarHistory, setOpenDollarHistory] = useState<boolean>(false);
    const [openInfoPODistribution, setOpenInfoPODistribution] = useState<boolean>(false);
    const [pODistributionTableData, setPODistributionTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });


    const handleCollapseAll = () => {
        setActiveIndex([]);
    };

    const handleExpandAll = () => {
        setActiveIndex([0, 1, 2, 3, 4, 5]);
    };

    const enable_Testing_Email = (rowData: IWebSite) => {
        if (rowData.enable_Testing_Email) return "Yes";
        return "No";
    };

    useEffect(() => {
        loadTableData();
    }, [globalFilter, props.reload]);

    const dt = useRef<any>(null);

    const confirmLogout = () => {
        confirmDialog({
            message: `Are you sure you want to logout all logged in users`,
            header: 'Confirm Logout All Users',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => logoutAll(),
            reject: () => { }
        });
    }

    async function logoutAll() {
        if (loading) return;
        setLoading(true);
        const response = await Fetch('Experiment/logout-all', 'POST', null, null, props.toast);
        if (response) {
            const data = await response.json();
            props.toast.current.show({ severity: 'success', detail: data.message });
        }
        setLoading(false);
    }

    async function sendNotification() {
        if (loading) return;
        setLoading(true);
        const response = await Fetch('Experiment/send-notification', 'POST', null, `message=${message}`, props.toast);
        if (response) {
            setMessage('');
        }
        setLoading(false);
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Website_Settings", "GET", null, `search=${globalFilter}`, props.toast);
        if (response) {
            const data: Array<IWebSite> = await response.json();
            setTableData({ tableData: data, loading: false });

        }
    }
    const openEdit = () => {
        props.setModal({ open: true, singleData: tableData.tableData[0] });
    };
    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Website Setting</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    const rightToolbarTemplate = () => {
        return <Button label="Update" icon="pi pi-pencil" className="p-button-success mr-2 bg-primary" onClick={openEdit} />
    }

    const leftToolbarTemplate = () => {
        return <>
            <Button label="Expand All" className="p-button-success mr-2 bg-primary" onClick={handleExpandAll} />
            <Button label="Collapse All" className="p-button-success mr-2 bg-primary" onClick={handleCollapseAll} />
        </>
    }

    const openDollarHistoryRate = () => {
        setOpenDollarHistory(prev => {
            if (prev === false) {
                loadDollarHistoryRate();
            }
            return prev = !prev;
        });
    }

    const openPOincDistribution = () => {
        setOpenInfoPODistribution(prev => {
            if (prev === false) {
                loadPOIncDistribution();
            }
            return prev = !prev;
        });
    }

    const loadDollarHistoryRate = async () => {
        setDollarHistoryTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Website_Settings/getDollarRate", "GET", null, null, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            setDollarHistoryTableData({ tableData: data, loading: false });
        } else {
            setDollarHistoryTableData({ tableData: tableData.tableData, loading: false });
        }
    }

    const loadPOIncDistribution = async () => {
        setPODistributionTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("PO_Incentive_Distribution", "GET", null, null, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            setPODistributionTableData({ tableData: data, loading: false });
        } else {
            setPODistributionTableData({ tableData: tableData.tableData, loading: false });
        }
    }
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion multiple activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} >
                <AccordionTab header="Client Contact Person Setting">
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        ref={dt}
                        value={tableData.tableData}
                        emptyMessage="No Data found."
                        loading={tableData.loading}>
                        <Column field="setting_Value" header="Record Person/Page Value" />
                    </DataTable>
                </AccordionTab>
                <AccordionTab header="Sales Allocation Setting">
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        ref={dt}
                        value={tableData.tableData}
                        emptyMessage="No Data found."
                        loading={tableData.loading}>
                        <Column field="experience_In" header="Experience In" />
                        <Column field="experience_Total" header="Experience Total" />
                        <Column field="number_Of_Allocation" header="Number Of Allocation" />
                    </DataTable>
                </AccordionTab>
                <AccordionTab header="Prime Vendor Performance Setting">
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        ref={dt}
                        value={tableData.tableData}
                        emptyMessage="No Data found."
                        loading={tableData.loading}>
                        <Column field="pV_Experience_In" header="Experience In" />
                        <Column field="pV_Experience_Duration_From" header="Experience From" />
                        <Column field="pV_Experience_Duration_To" header="Experience To" />
                        <Column field="pV_Number_Of_Allocation" header="Number Of Allocation" />
                        <Column field="pV_Calculation_In" header="Calculate In" />
                        <Column field="pV_Calculation_Duration" header="Calculate" />
                        <Column field="number_Picked_Vendor" header="Number Of Picked Vendor" />
                        <Column field="notification_Time" header="Notification Time (in minutes)" />
                    </DataTable>
                </AccordionTab>
                <AccordionTab header="Requirement Float Setting">
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        ref={dt}
                        value={tableData.tableData}
                        emptyMessage="No Data found."
                        loading={tableData.loading}>
                        <Column field="send_Unserved_Req_Mail" header="Float Requirement Time (in minutes)" />
                        <Column field="float_Req_Gap_Time" header="Float Requirement Gap Time" />
                    </DataTable>
                </AccordionTab>
                <AccordionTab header="Submission Setting">
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        ref={dt}
                        value={tableData.tableData}
                        emptyMessage="No Data found."
                        loading={tableData.loading}>
                        <Column field="no_Sub_Per_Req" header="Max sub on req" />
                        <Column field="req_Hold_After_Sub" header="Req hold after sub" />
                    </DataTable>
                </AccordionTab>
                <AccordionTab header="Allocation Schedular Setting">
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        ref={dt}
                        value={tableData.tableData}
                        emptyMessage="No Data found."
                        loading={tableData.loading}>
                        <Column field="allocation_Schedular_Start_Time" header="Allocation Script Schedular Time" />
                    </DataTable>
                </AccordionTab>
                <AccordionTab header="Add Requirement Setting">
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        ref={dt}
                        value={tableData.tableData}
                        emptyMessage="No Data found."
                        loading={tableData.loading}>
                        <Column field="add_Req_Start_Time" header="Add Requirement Start Time" />
                        <Column field="add_Req_End_Time" header="Add Requirement End Time" />
                    </DataTable>
                </AccordionTab>
                <AccordionTab header="Testing Email Setting">
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        ref={dt}
                        value={tableData.tableData}
                        emptyMessage="No Data found."
                        loading={tableData.loading}>
                        <Column field="enable_Testing_Email" body={enable_Testing_Email} header="Enable Testing Email" />
                    </DataTable>
                </AccordionTab>
                <AccordionTab header="Dollar Rate">
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        ref={dt}
                        stripedRows resizableColumns showGridlines columnResizeMode="expand"
                        value={tableData.tableData}
                        emptyMessage="No Data found."
                        loading={tableData.loading}>
                        <Column field="dollar_Rate" header="Dollar Rate" />
                        <Column field="dollar_Rate_Hitory" header="History" body={() => <i className="pi pi-history p-primary" style={{ color: "blue", cursor: "pointer" }} onClick={() => openDollarHistoryRate()}></i>} />
                    </DataTable>
                </AccordionTab>
                <AccordionTab header="Po Incentive Distribution">
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        ref={dt}
                        stripedRows resizableColumns showGridlines columnResizeMode="expand"
                        value={tableData.tableData}
                        emptyMessage="No Data found."
                        loading={tableData.loading}>
                        <Column field="" header="Info Of PO Inc Distribution" body={() => <i className="pi pi-eye p-primary" style={{ color: "blue", cursor: "pointer" }} onClick={() => openPOincDistribution()}></i>} />
                    </DataTable>
                </AccordionTab>
                <AccordionTab header="Search Consultant Email Sending Setting">
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        ref={dt}
                        stripedRows resizableColumns showGridlines columnResizeMode="expand"
                        value={tableData.tableData}
                        emptyMessage="No Data found."
                        loading={tableData.loading}>
                        <Column field="maxConsultantSelections" header="Max Consultant Selections" />
                        <Column field="maxEmailSendToConsultant" header="Max Email Send To Consultant" />
                    </DataTable>
                </AccordionTab>
                <AccordionTab header="Team Lead Margin Percentage On Team Expenses">
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                        size="small"
                        ref={dt}
                        stripedRows resizableColumns showGridlines columnResizeMode="expand"
                        value={tableData.tableData}
                        emptyMessage="No Data found."
                        loading={tableData.loading}>
                        <Column field="team_Lead_Margin_Team_Expenses_Percentage" header="Team Lead Margin Percentage On Team Expenses" body={(rowData: any) => <p>{rowData.team_Lead_Margin_Team_Expenses_Percentage} <span style={{ fontWeight: "bolder" }}>%</span></p>} />
                        {/* <Column field="team_Lead_Margin_Dollar" header="Team Lead Margin Dollar per lakh $" body={(rowData: any) => <p><span style={{ fontWeight: "bolder" }}>$</span> {rowData.team_Lead_Margin_Dollar}</p>} />
                        <Column field="team_Lead_Margin_Cal_Months" header="Team Lead Months Margin Calculation (It will consider from previous months, if months count is 2 then it will consider current months previous month and ( previous month of current months previous month ) )" /> */}
                    </DataTable>
                </AccordionTab>
                <AccordionTab header="Logout All Users">
                    <Button loading={loading} className="p-button-danger" onClick={confirmLogout}>Logout All Users</Button>
                </AccordionTab>
                <AccordionTab header="Send Notification to all users">
                    <InputTextarea maxLength={500} value={message} style={{ width: '100%' }} onChange={e => setMessage(e.target.value)} />
                    <Button loading={loading} onClick={() => sendNotification()} icon="pi pi-send" className="p-button-rounded" aria-label="Send" label="Send" />
                </AccordionTab>
            </Accordion>


            <Dialog visible={openDollarHistory} style={{ width: '80vw' }} header="Dollar Rate Change History" modal className="p-fluid" onHide={openDollarHistoryRate} maximizable>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    stripedRows resizableColumns showGridlines columnResizeMode="expand"
                    size="small"
                    ref={dt}
                    value={dollarHistoryTableData.tableData}
                    emptyMessage="No Data found."
                    loading={dollarHistoryTableData.loading}>
                    <Column field="prev_Dollar" header="Previous Dollar" />
                    <Column field="current_Dollar" header="Current Dollar" />
                    <Column field="updated_By" header="Updated By" />
                    <Column field="updated_On" header="Updated On" body={(rowData: any) => safeFormatDate(rowData.updated_On, "dd/MM/yyyy", DateFormat)} />
                </DataTable>
            </Dialog>

            <Dialog visible={openInfoPODistribution} style={{ width: '80vw' }} header="PO Incentive Distribution" modal className="p-fluid" onHide={openPOincDistribution} maximizable>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    stripedRows resizableColumns showGridlines columnResizeMode="expand"
                    size="small"
                    ref={dt}
                    value={pODistributionTableData.tableData}
                    emptyMessage="No Data found."
                    loading={pODistributionTableData.loading}>
                    <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                    <Column field="inc_Per" header="Inc Per(%)" />
                    <Column field="role_Name" header="Role Name" />
                    <Column field="created_By" header="Created By" />
                    <Column field="updated_By" header="Updated By" />
                    <Column field="created_On" header="Created On" body={(rowData: any) => safeFormatDate(rowData.created_On, "dd/MM/yyyy", DateFormat)} />
                    <Column field="updated_On" header="Updated On" body={(rowData: any) => safeFormatDate(rowData.updated_On, "dd/MM/yyyy", DateFormat)} />
                </DataTable>
            </Dialog>
            <ConfirmDialog />
        </>
    );
}

